export const IconFilterActive = () => {
  return (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.5" y="1" width="37" height="36" rx="7" fill="#053462" />
      <rect
        x="1.5"
        y="1"
        width="37"
        height="36"
        rx="7"
        stroke="#053462"
        strokeWidth="2"
      />
      <path
        d="M28.334 14.417H23.334"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9993 14.417H11.666"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 17.3333C19.9435 17.3333 21.2493 16.0275 21.2493 14.4167C21.2493 12.8058 19.9435 11.5 18.3327 11.5C16.7219 11.5 15.416 12.8058 15.416 14.4167C15.416 16.0275 16.7219 17.3333 18.3327 17.3333Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3333 23.583H25"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.666 23.583H11.666"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6667 26.5003C23.2775 26.5003 24.5833 25.1945 24.5833 23.5837C24.5833 21.9728 23.2775 20.667 21.6667 20.667C20.0558 20.667 18.75 21.9728 18.75 23.5837C18.75 25.1945 20.0558 26.5003 21.6667 26.5003Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
